import { render, staticRenderFns } from "./Culture.vue?vue&type=template&id=c6003800&"
import script from "./Culture.vue?vue&type=script&lang=js&"
export * from "./Culture.vue?vue&type=script&lang=js&"
import style0 from "./Culture.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports